import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/login.vue'
import Openvip from '../components/Openvip.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home'
}, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
        title: '海查查-登录',
        auth: false
    }
}, {
    path: '/openvip',
    name: 'Openvip',
    component: Openvip,
    meta: {
        title: '海查查-会员服务',
        auth: false
    }
}, {
    path: '',
    component: () =>
        import ('@/views/layout'),
    children: [{
            path: "/home",
            component: resolve => require(['@/views/home/index.vue'], resolve),
            meta: {
                title: "海查查-企业列表",
                auth: true,
                keepAlive: true
            }
        }, {
            path: "/home/detail",
            component: resolve => require(['@/views/home/detail.vue'], resolve),
            meta: {
                title: "海查查-企业详情",
                auth: true
            }
        }, {
            path: "/vip",
            component: resolve => require(['@/views/vip/index.vue'], resolve),
            meta: {
                title: "海查查-会员中心",
                auth: true
            }
        }, {
            path: "/vip/buy",
            component: resolve => require(['@/views/vip/buy.vue'], resolve),
            meta: {
                title: "海查查-购买会员",
                auth: true
            }
        }, {
            path: "/vip/payment",
            component: resolve => require(['@/views/vip/Payment.vue'], resolve),
            meta: {
                title: "海查查-提交订单",
                auth: true
            }
        },
        {
            path: '',
            component: () =>
                import ('@/views/user/index'),
            children: [{
                path: "/user/history",
                name: '浏览历史',
                component: resolve => require(['@/views/user/history.vue'], resolve),
                meta: {
                    title: "海查查-个人中心-浏览历史",
                    auth: true
                }
            }, {
                path: "/user/care",
                name: '我的关注',
                component: resolve => require(['@/views/user/care.vue'], resolve),
                meta: {
                    title: "海查查-个人中心-我的关注",
                    auth: true
                }
            }, {
                path: "/user/company",
                name: '我的企业',
                component: resolve => require(['@/views/user/company.vue'], resolve),
                meta: {
                    title: "海查查-个人中心-我的企业",
                    auth: true
                }
            }, {
                path: "/user/team",
                name: '我的团队',
                component: resolve => require(['@/views/user/team.vue'], resolve),
                meta: {
                    title: "海查查-个人中心-我的团队",
                    auth: true
                }
            }, {
                path: "/user/buy",
                name: '购买记录',
                component: resolve => require(['@/views/user/buy.vue'], resolve),
                meta: {
                    title: "海查查-个人中心-购买记录",
                    auth: true
                }
            }, {
                path: "/user/invoice",
                name: '我的发票',
                component: resolve => require(['@/views/user/invoice.vue'], resolve),
                meta: {
                    title: "海查查-个人中心-我的发票",
                    auth: true
                }
            }]
        }, {
            path: "/addinvoice",
            name: 'addinvoice',
            component: resolve => require(['@/views/user/addinvoice.vue'], resolve),
            meta: {
                title: "海查查-填写开票信息",
                auth: true
            }
        },
    ]
}]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop
            }
            return {
                x: 0,
                y: to.meta.savedPosition || 0
            }
        }
    }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err)
    }
    // 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    const tokenStr = window.localStorage.getItem('token')
    if (!to.matched.some(record => record.meta.auth == false) && !tokenStr) {
        next('/login')
    } else {
        next()
    }
    if (to.meta.title) {
        document.title = to.meta.title
    }
})
export default router